import React from 'react';
import { portfolioData } from '../../../../data/portfolio';

const SkillCard = props => {
    const { skills } = portfolioData;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
            <h3 className="text-xl font-bold text-gray-900 mb-6 font-display border-b border-gray-100 pb-2">Technical Skills</h3>
            <div className="space-y-6">
                {Object.entries(skills).map(([category, skillList]) => (
                    <div key={category} className="category">
                        <h4 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3">{category}</h4>
                        <div className="flex flex-wrap gap-2">
                            {skillList.map(skill => (
                                <span
                                    key={skill}
                                    className="px-3 py-1 text-sm font-medium text-gray-700 bg-gray-50 rounded-lg border border-gray-200 hover:bg-primary-50 hover:text-primary-600 hover:border-primary-200 transition-all duration-200 cursor-default"
                                >
                                    {skill}
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

SkillCard.propTypes = {};

export default SkillCard;
